import React from "react";
import {
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignStartHorizontal,
  AlignStartVertical,
  Group,
  Ungroup,
} from "lucide-react";
import {
  handleAlignCanvasObject,
  handleGroupObjects,
  handleUngroupObjects,
} from "../../../lib/shapes";

const iconsObjects = [
  {
    key: "groupObjects",
    component: Group,
    title: "Group Objects",
  },
  {
    key: "ungroupObjects",
    component: Ungroup,
    title: "Ungroup Objects",
  },
];

const GroupControl = ({
  fabricRef,
  syncShapeInStorage,
  deleteShapeFromStorage,
  suppressHistoryRef,
  saveStateToHistory,
}: any) => {
  return (
    <section className="flex flex-col border-b border-borderColor">
      <div className="px-2 py-5">
        <div className="mb-2">
          <h3 className="text-[10px] uppercase px-1">Group Control</h3>
        </div>

        <div className="flex flex-row items-center justify-between gap-1">
          {iconsObjects.map((icon) => (
            <div
              key={icon.key}
              title={icon.title}
              className="p-1 rounded hover:bg-black group"
              onClick={() => {
                if (icon.key === "groupObjects") {
                  handleGroupObjects({
                    fabricRef,
                    canvas: fabricRef.current,
                    syncShapeInStorage,
                    deleteShapeFromStorage,
                    suppressHistoryRef,
                    saveStateToHistory,
                  });
                } else {
                  handleUngroupObjects({
                    canvas: fabricRef.current,
                    syncShapeInStorage,
                    deleteShapeFromStorage,
                    suppressHistoryRef,
                    saveStateToHistory,
                  });
                }
              }}
            >
              <icon.component
                size={20}
                className="text-body group-hover:cursor-pointer group-hover:text-primary"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GroupControl;
